export * from './forum.services';

import {
  sendMsg,
  ENDPOINT_REQUEST as userServicesRequest,
  SERVICES_REQUEST as services,
} from '../../configurations';
import { PARAMS as rqParams } from '../../constants/params';

// Call services to WinVestor Login and Get Account Info
export const winVestLogin = (params, callback) => {
  sendMsg(services.WIN_VEST, userServicesRequest.wAUTH.WIN_VEST_LOGIN, params).post(res => {
    callback(res);
  })
}

// Call services to WinVestor Register Account Info
export const winVestRegister = (params, callback) => {
  sendMsg(services.WIN_VEST, userServicesRequest.wAUTH.WIN_VEST_REGISTER, params).post(res => {
    callback(res);
  })
}

// Call services to WinVestor GET Account Info
export const winVestViewCustomer = (params, callback) => {
  sendMsg(services.WIN_VEST, userServicesRequest.wAUTH.WIN_VEST_VIEW_CUSTOMER.replace('{0}', params[rqParams.ID]), params).get(res => {
    callback(res);
  })
}

// Call services to WinVestor EDIT Account Info
export const winVestUpdateCustomer = (params, callback) => {
  sendMsg(services.WIN_VEST, userServicesRequest.wAUTH.WIN_VEST_UPDATE_CUSTOMER.replace('{0}', params[rqParams.ID]), params).put(res => {
    callback(res);
  })
}

// Call services to WinVestor GET REGIONS
export const winVestGetRegion = (params, callback) => {
  sendMsg(services.WIN_VEST, userServicesRequest.wCOMMON.RETRIEVE_REGION, params).get(res => {
    callback(res);
  })
}

// Call services to WinVestor Logout
export const winVestLogout = (params, callback) => {
  sendMsg(services.WIN_VEST, userServicesRequest.wAUTH.WIN_VEST_LOGOUT, params).post(res => {
    callback(res);
  })
}

export const winVestSwitchLanguage = (params, callback) => {
  sendMsg(services.WIN_VEST, userServicesRequest.wUSER.SWITCH_LANGUAGE.replace('{0}', params[rqParams.ID]), params).post(res => {
    callback(res);
  })
}